// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
/* eslint-disable */
import Vue from 'vue'
import App from './App'
import router from './router'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/build/css/mdb.css'
import './assets/css/admin-styles.css'
import 'vue-search-select/dist/VueSearchSelect.css'
import Vuelidate from 'vuelidate'
import VueTilt from "vue-tilt.js";
import VueMoment from 'vue-moment'
import moment from 'moment-timezone' 
import store from './store'
import * as io from 'socket.io-client'
import VueSocketIO from 'vue-socket.io'
import './assets/tailwind.css'

// Vue.use(VueGoogleMaps, {
//   load: {
//     libraries: 'places'
//   }
// })

Vue.use(Vuelidate)
Vue.use(VueSocketIO, io('https://ws.myfrac.com'))
Vue.use(VueTilt)
Vue.use(VueMoment, {
  moment,
});



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

